import { UnderConstructionComponent } from '@components/shared/under-construction/under-construction.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-users',
  imports: [UnderConstructionComponent],
  templateUrl: './users.component.html'
})
export class UsersComponent {}
